<template>
    <b-btn
            class="refresh-button align-self-start py-1 px-2"
            variant="outline-primary"
            @click="$emit('click')"
    >
        <font-awesome-icon
                :icon="['far', 'sync-alt']"
                :spin="spinning"
                class="align-self-baseline"
        >
        </font-awesome-icon>
    </b-btn>
</template>

<script>
    export default {
        name: 'Refresh-button',
        props: {
            spinning: Boolean,
        }
    };
</script>
